<template>
  <div>
    <v-list-item @click.prevent="printCertification">
      <v-container v-if="$vuetify.breakpoint.name !== 'xs'" fluid fill-height>
        <v-row align="center" justify="center">
          <v-col class="text-right" cols="3">
            <v-avatar width="106.8" height="59.8" tile>
              <img :src="require(`@/assets/courseData/courseCardImg/${card.coursePhoto}`)" width="100" />
            </v-avatar>
          </v-col>

          <v-col cols="5">
            <v-card-subtitle class="text-caption text-left py-0" v-text="card.courseName" />
            <v-card-subtitle v-if="card.instructorAffiliation !== null" class="grey--text text-left text-caption py-0" v-text="`${card.instructor} / ${card.instructorAffiliation}`" />
            <v-card-subtitle v-else class="grey--text text-left text-caption py-0" v-text="`${card.instructor}`" />
            <v-card-subtitle class="grey--text text-left text-caption py-0" v-text="`${card.schedule}`" />
          </v-col>

          <v-col cols="3">
            <div align="start" class="ml-3">
              <v-chip v-if="courseStatus === 'certificated-unissued' && cardType !== 'finished'" small class="mr-1" color="black" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                発行可能
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-issued' && cardType !== 'finished'" small class="mr-1" color="grey darken-1" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                発行済
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-unissued' && cardType === 'finished'" small class="mr-1" color="green darken-4" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-issued' && cardType === 'finished'" small class="mr-1" color="green darken-4" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
              <v-chip v-if="courseStatus === 'unpassed'" small class="mr-1" color="orange darken-4" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-arrow-right-drop-circle-outline
                  </v-icon>
                </v-avatar>
                受講中
              </v-chip>
              <v-chip v-if="courseStatus === 'failed-unfinished'" small class="mr-1" color="orange" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon>
                    mdi-triangle
                  </v-icon>
                </v-avatar>
                受講中
              </v-chip>
              <v-chip v-if="courseStatus === 'failed-finished'" small class="mr-1" color="green" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon>
                    mdi-triangle
                  </v-icon>
                </v-avatar>
                終了
              </v-chip>
              <v-chip v-if="courseStatus === 'passed'" small class="mr-1" color="green darken-4" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else fluid fill-height mx-0 px-0>
        <v-row align="center" justify="space-around">
          <v-col class="text-right" cols="4">
            <v-avatar width="106.8" height="59.8" tile>
              <img :src="require(`@/assets/courseData/courseCardImg/${card.coursePhoto}`)" width="100" />
            </v-avatar>
          </v-col>

          <v-col cols="8">
            <v-card-subtitle class="text-caption text-left py-0 ml-4" v-text="card.courseName" />
            <div class="text-left ml-7 py-1">
              <v-chip v-if="courseStatus === 'certificated-unissued' && cardType !== 'finished'" small class="mr-1" color="black" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                発行可能
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-issued' && cardType !== 'finished'" small class="mr-1" color="grey darken-3" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                発行済
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-unissued' && cardType === 'finished'" small class="mr-1" color="green darken-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
              <v-chip v-if="courseStatus === 'certificated-issued' && cardType === 'finished'" small class="mr-1" color="green darken-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
              <v-chip v-if="courseStatus === 'unpassed'" small class="mr-1" color="orange darken-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-arrow-right-drop-circle-outline
                  </v-icon>
                </v-avatar>
                受講中
              </v-chip>
              <v-chip v-if="courseStatus === 'failed-unfinished'" small class="mr-1" color="orange lighten-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon>
                    mdi-triangle
                  </v-icon>
                </v-avatar>
                受講中
              </v-chip>
              <v-chip v-if="courseStatus === 'failed-finished'" small class="mr-1" color="green lighten-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon>
                    mdi-triangle
                  </v-icon>
                </v-avatar>
                終了
              </v-chip>
              <v-chip v-if="courseStatus === 'passed'" small class="mr-1" color="green darken-2" text-color="white">
                <v-avatar left class="mr-0 pa-0">
                  <v-icon small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-avatar>
                修了
              </v-chip>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    courseStatus: {
      type: String,
      required: true
    },
    cardType: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    printCertification: function () {
      this.$router.push(`${this.to}`)
    }
  }
}
</script>
